import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Table, InputGroup, Spinner } from "react-bootstrap";
import "./_lecturerTimeTable.scss"
import moment from "moment";
import DateBlock from '../home/DateBlock';
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import PeriodCreationModal from './period_creation_popup/PeriodCreationModal';
import TimeTableCreationModal from './timetable_creation_popup/timeTableCreationModal';



class LecturerTimeTableHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branch_id: "",
            class_id: "",
            exam_id: "",
            section_id: "",
            branchError: "",
            classError: "",
            examError: "",
            sectionError: "",
            dateError: "",
            loader: 0,
            startDateCalender: moment(new Date()).subtract(5, "days").startOf('day').unix(),
            endDateCalender: moment(new Date()).startOf('day').unix(),
            filteredData: [],
            filterValue: '',
            lecturer_time_table: [],
            tableHeading: [],
            noDateError: "",
            searchValue: "",
            periodCreationModal: false,
            timeTableCreationModal: false,
            getExams: [],
            getClasses: [],
            getSections: [],
            defaultvalue: 0
        }
    }
    handleInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;

        let getArray = [];

        if (name == "branch") {

            if (value != "0") {
                let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();

                uniqueExams.map((val) => {
                    let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualExamData.id,
                        label: individualExamData.exam
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    class_id: "",
                    exam_id: "",
                    section_id: "",
                    noDateError: "",
                    lecturer_time_table: [],
                    tableHeading: [],
                    branch_id: value,
                    branchError: "",
                    getExams: getArray,
                    getClasses: [],
                    getSections: [],
                    examError: "",
                    classError: "",
                    sectionError: "",
                    dateError: ""

                })
            } else {
                this.setState({
                    class_id: "",
                    exam_id: "",
                    section_id: "",
                    noDateError: "",
                    lecturer_time_table: [],
                    tableHeading: [],
                    branch_id: "",
                    branchError: "",
                    getExams: [],
                    getClasses: [],
                    getSections: [],
                    examError: "",
                    classError: "",
                    sectionError: "",
                    dateError: ""
                })
            }
        }
        if (name == "class") {

            if (value != "0") {

                let uniqueSections = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branch_id && item.exam_id == this.state.exam_id && item.class_id == value).map((item1) => item1.section_id))].sort();

                uniqueSections.map((val) => {
                    let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualSectionData.id,
                        label: individualSectionData.section_name
                    }
                    getArray.push(newObj);
                })

                let sections = getArray.map((item) => item.value).toString();

                this.setState({
                    class_id: value,
                    section_id: "",
                    noDateError: "",
                    lecturer_time_table: [],
                    tableHeading: [],
                    branchError: "",
                    getSections: getArray,
                    examError: "",
                    classError: "",
                    sectionError: "",
                    dateError: ""
                })

            } else {

                this.setState({
                    class_id: "",
                    section_id: "",
                    noDateError: "",
                    lecturer_time_table: [],
                    tableHeading: [],
                    branchError: "",
                    getSections: [],
                    examError: "",
                    classError: "",
                    sectionError: "",
                    dateError: ""
                })

            }
        }
        if (name == "exam") {

            if (value != "0") {


                let uniqueClasses = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branch_id && item.exam_id == value).map((item1) => item1.class_id))].sort();

                uniqueClasses.map((val) => {
                    let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualClassData.id,
                        label: individualClassData.class
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    class_id: "",
                    exam_id: value,
                    section_id: "",
                    noDateError: "",
                    lecturer_time_table: [],
                    tableHeading: [],
                    branchError: "",
                    getClasses: getArray,
                    getSections: [],
                    examError: "",
                    classError: "",
                    sectionError: "",
                    dateError: ""
                })
            } else {
                this.setState({
                    class_id: "",
                    exam_id: "",
                    section_id: "",
                    noDateError: "",
                    lecturer_time_table: [],
                    tableHeading: [],
                    branchError: "",
                    getClasses: [],
                    getSections: [],
                    examError: "",
                    classError: "",
                    sectionError: "",
                    dateError: ""
                })

            }
        }
        if (name == "section") {

            if (value != "0") {

                this.setState({
                    lecturer_time_table: [],
                    tableHeading: [],
                    noDateError: "",
                    section_id: value, sectionError: "",
                })

            } else {

                this.setState({
                    lecturer_time_table: [],
                    tableHeading: [],
                    noDateError: "",
                    section_id: "",
                    sectionError: "",
                })
            }

            this.getClassPeriods();
        }

    };


    getClassPeriods = async () => {
        const periods = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,$exam_id:Int){
                getClassPeriodsTimings(institute_id:$institute_id,branch_id:$branch_id,exam_id:$exam_id){
                    period_id
                    period_name
                    period_time
                  }
               }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch_id),
                exam_id: parseInt(this.state.exam_id)
            },
            fetchPolicy: 'network-only'
        })

        if (periods.data.getClassPeriodsTimings.length > 0) {

            let tableHeading = [];

            periods.data.getClassPeriodsTimings.map((item) => {
                tableHeading.push({ label: item.period_name, period_id: item.period_id })
            })

            this.setState({ tableHeading: tableHeading })

        }

    }

    getDisplayData = async (e) => {


        if (this.state.branch_id === "" || this.state.branch_id === "--Select Branch--") {
            this.setState({ branchError: "Please Select Branch", variables: [] });
            return ""
        }


        if (this.state.exam_id === "" || this.state.exam_id === "--Select Exam--") {
            this.setState({ examError: "Please Select Exam", variables: [] });
            return ""
        }

        if (this.state.class_id === "" || this.state.class_id === "--Select Class--") {
            this.setState({ classError: "Please Select Class", variables: [] });
            return ""
        }


        if (this.state.section_id === "" || this.state.section_id === "--Select Section--") {
            this.setState({ sectionError: "Please Select Section", variables: [] });
            return ""
        }
        this.setState({ loader: 1 })
        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,$exam_id:Int,$section_id:Int,$class_start_date:String,$class_id:Int,$class_end_date:String){
                getClassTimeTable(institute_id:$institute_id,branch_id:$branch_id,exam_id:$exam_id,section_id:$section_id,class_start_date:$class_start_date,class_id:$class_id,class_end_date:$class_end_date){
                    class_day_type_id
                    class_period_id
                    period_name
                    subject_id
                    subject_name
                    employee_id
                    employee_name
                    class_topic
                    class_date
                }
              }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branch_id),
                class_id: parseInt(this.state.class_id),
                section_id: parseInt(this.state.section_id),
                exam_id: parseInt(this.state.exam_id),
                class_start_date: this.state.startDateCalender.toString(),
                class_end_date: this.state.endDateCalender.toString()
            },
            fetchPolicy: 'network-only'
        });

        //console.log("result", result.data);

        if (result.data.getClassTimeTable.length > 0) {
            let data = result.data.getClassTimeTable;

            let array = [];

            let uniqueDates = new Set(data.map((item) => item.class_date));

            //console.log("unique", uniqueDates);

            uniqueDates.map((item) => {
                let dayWiseSchedule = data.filter((item1) => item1.class_date == item);
                let date = moment.unix(+item).format("DD-MM-YYYY");
                let period_details = [];
                dayWiseSchedule.map((item1) => {
                    period_details.push({ class_day_type_id: item1.class_day_type_id, class_period_id: item1.class_period_id, period_details: `${item1.subject_name} - ${item1.employee_name}`, class_topic: item1.class_topic, subject_name: item1.subject_name, employee_name: item1.employee_name })
                })
                array.push({ date, period_details })
            })
            this.setState({ lecturer_time_table: array, loader: 0 })
        } else {
            this.setState({ loader: 0, noDateError: "No Data Available" })
        }
    }

    applyCallback = (startDate, endDate) => {
        this.setState({
            branch_id: "",
            class_id: "",
            exam_id: "",
            section_id: "",
            lecturer_time_table: [],
            tableHeading: [],
            noDateError: "",
            startDateCalender: startDate.startOf('day').unix(),
            endDateCalender: endDate.startOf('day').unix(),
            getExams: [],
            getClasses: [],
            getSections: [],
        })
    }

    downloadPDF = () => {
        alert('Download button clicked');
    }


    handleFilterChange = (e) => {
        let value = e.target.value;



        const filteredData = this.state.lecturer_time_table.filter((item) => {
            return item.date.includes(value);
        });

        console.log("filter", filteredData, value);

        this.setState({ searchValue: value });
    };

    render() {
        console.log("mahesh", this.state);
        return (
            <section className='lecturer-table'>
                <Container>
                    <div className='d-flex justify-content-end'>
                        <div>
                            <Button className="text-uppercase submit_btn" style={{width:"160px"}} onClick={() => { this.setState({ periodCreationModal: true }) }}>Period Creation</Button>
                        </div>
                        <div className='ml-2'>
                            <Button className="text-uppercase submit_btn" style={{width:"193px"}} onClick={() => { this.setState({ timeTableCreationModal: true }) }}>TimeTable Creation</Button>
                        </div>
                    </div>
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12}>
                            <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                                <h2 className="text-uppercase title h5 mb-0">Lecturers TimeTable</h2>

                                <div className="filter-block d-flex align-items-center mr-4">
                                    <Form.Group className="customDate mb-0 mr-4" controlId="StartDate" style={{ width: 180 }}>
                                        <DateBlock applyCallback={this.applyCallback} start={this.start} end={this.end}
                                            stateData={this.props.stateData}
                                        />
                                    </Form.Group>
                                </div>
                            </div>
                        </Col>


                        <Col xl={12} lg={12} md={12} sm={12}>
                            <Form>
                                <Form.Row>
                                    <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                                        <Form.Label className="text-uppercase font-weight-bold">Branch</Form.Label>
                                        <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch_id} isInvalid={this.state.branchError}>
                                            <option value={this.state.defaultvalue}>--Select Branch--</option>
                                            {this.props.globals.globalBranches.map(branchdata => (
                                                <option key={branchdata.id} value={branchdata.id}>
                                                    {branchdata.branch_name}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.branchError}
                                        </Form.Text>
                                    </Form.Group>


                                    <Form.Group as={Col} lg={2} md={12} sm={12} controlId="Selectexam">
                                        <Form.Label className="text-uppercase font-weight-bold">Exam</Form.Label>
                                        <Form.Control as="select" name="exam" onChange={this.handleInputChange} value={this.state.exam_id} isInvalid={this.state.examError}>
                                            <option value={this.state.defaultvalue}>--Select Exam--</option>
                                            {this.state.getExams.map(item => (
                                                <option key={item.value} value={item.value}>
                                                    {item.label}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.examError}
                                        </Form.Text>
                                    </Form.Group>


                                    <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                                        <Form.Label className="text-uppercase font-weight-bold">Class</Form.Label>
                                        <Form.Control as="select" name="class" onChange={this.handleInputChange} value={this.state.class_id} isInvalid={this.state.classError}>
                                            <option value={this.state.defaultvalue}>--Select Class--</option>
                                            {this.state.getClasses.map(classdata => (
                                                <option key={classdata.value} value={classdata.value}>
                                                    {classdata.label}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.classError}
                                        </Form.Text>
                                    </Form.Group>



                                    <Form.Group as={Col} lg={2} md={12} sm={12} controlId="SelectClass">
                                        <Form.Label className="text-uppercase font-weight-bold">Section</Form.Label>
                                        <Form.Control as="select" name="section" onChange={this.handleInputChange} value={this.state.section_id} isInvalid={this.state.sectionError}>
                                            <option value={this.state.defaultvalue}>--Select Section--</option>
                                            {this.state.getSections.map(sectiondata => (
                                                <option key={sectiondata.value} value={sectiondata.value}>
                                                    {sectiondata.label}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.sectionError}
                                        </Form.Text>
                                    </Form.Group>


                                    <Form.Group as={Col} lg={4} md={12} sm={12} controlId="Selectexam">
                                        <Button className="text-uppercase submit_btn" onClick={this.getDisplayData}>Get TimeTable</Button>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        </Col>
                    </Row>
                    {
                        this.state.lecturer_time_table.length > 0 ? (
                            <>

                                <Row>
                                    <Col xl={12} lg={12} md={12}>
                                        <div className="table-container increased-height" style={{ maxHeight: "500px", overflowY: "auto" }}>
                                            <Table className=" table  table-bordered table-custom" cellSpacing="0" style={{ width: "100%" }}>
                                                <thead className="text-center" style={{ backgroundColor: "#213046", color: "#ffffff" }}>
                                                    <tr>
                                                        <th >S.No.</th>
                                                        <th>Date</th>
                                                        {
                                                            this.state.tableHeading.map((item) => (
                                                                <>
                                                                    <th>{item.label}</th>
                                                                </>
                                                            ))
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody >

                                                    {

                                                        this.state.lecturer_time_table.map((item, index) => {

                                                            let bgColor = "";
                                                            if (item.period_details[0].class_day_type_id == 2) {
                                                                bgColor = "#edab68"
                                                            } else if (item.period_details[0].class_day_type_id == 4) {
                                                                bgColor = "#ffceec"
                                                            } else if (item.period_details[0].class_day_type_id == 3) {
                                                                bgColor = " #71ce7e"
                                                            }
                                                            else {
                                                                bgColor = "#8ed1fc"
                                                            }

                                                            let sno = index + 1;
                                                            return (
                                                                <>
                                                                    <tr>
                                                                        <td className='text-center' >{sno}</td>
                                                                        <td style={{ width: "100px" }}>{item.date}</td>
                                                                        {
                                                                            (item.period_details[0].class_day_type_id == 2 || item.period_details[0].class_day_type_id == 4) ? (
                                                                                <td className='text-center' style={{ backgroundColor: bgColor }} colSpan={this.state.tableHeading.length} ><h6>{item.period_details[0].class_topic}</h6></td>
                                                                            ) : (
                                                                                this.state.tableHeading.map((item1) => {
                                                                                    let filteredTimeTable = item.period_details.filter((item2) => item1.period_id == item2.class_period_id);
                                                                                    if (filteredTimeTable.length > 0) {
                                                                                        return (
                                                                                            <>
                                                                                                <td >
                                                                                                    <h6 className='text-center' >{filteredTimeTable[0].class_topic}</h6>
                                                                                                    <p className='text-center' >{filteredTimeTable[0].subject_name} - {filteredTimeTable[0].employee_name}</p>
                                                                                                </td>
                                                                                            </>
                                                                                        )
                                                                                    } else {
                                                                                        return (
                                                                                            <td className='text-center'>-</td>
                                                                                        )
                                                                                    }
                                                                                })
                                                                            )
                                                                        }
                                                                    </tr>
                                                                </>
                                                            )
                                                        })

                                                    }

                                                </tbody>
                                            </Table>

                                        </div>
                                    </Col>
                                </Row>
                            </>
                        ) : ("")
                    }

                    {
                        this.state.loader == 1 ?
                            (
                                <div className="spinner-border text-primary text-center loading-img-center"></div>
                            )
                            :
                            ("")
                    }

                    {
                        this.state.noDateError != "" ?
                            (
                                <h6 className='d-flex justify-content-center align-content-center'>{this.state.noDateError}</h6>
                            )
                            :
                            ("")
                    }


                    <PeriodCreationModal
                        globals={this.props.globals}
                        stateData={this.state}
                        show={this.state.periodCreationModal}
                        onHide={() => this.setState({ periodCreationModal: false })}
                    />

                    <TimeTableCreationModal
                        globals={this.props.globals}
                        stateData={this.state}
                        show={this.state.timeTableCreationModal}
                        onHide={() => this.setState({ timeTableCreationModal: false })}
                    />



                </Container>
            </section>
        )
    }
}

export default withRouter(withApollo((LecturerTimeTableHome)));